import React, { useContext } from "react";
import { GlobalContext } from "../contexts/GlobalContext";

const Profile = () => {
  const { state } = useContext(GlobalContext);
  const { user } = state;

  return (
    <div className="flex flex-col items-center p-6 max-w-md mx-auto bg-white rounded-xl shadow-md">
      <img
        src={user.image_url}
        alt="Profile"
        className="w-32 h-32 rounded-full border border-gray-300 mb-4"
      />
      <div className="text-center">
        <h2 className="text-2xl font-semibold mb-1">{user.name}</h2>
        <p className="text-gray-600">{user.email}</p>
      </div>
    </div>
  );
};

export default Profile;
